var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIconGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.919922 3.10358C0.919922 2.81823 1.17437 2.58691 1.48826 2.58691H11.7183C12.0321 2.58691 12.2866 2.81823 12.2866 3.10358C12.2866 3.38893 12.0321 3.62025 11.7183 3.62025H1.48826C1.17437 3.62025 0.919922 3.38893 0.919922 3.10358Z",
    fill: "#BCC6D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.44063 1.64729C5.28647 1.64729 5.13863 1.70668 5.02962 1.81238C4.92061 1.91808 4.85938 2.06144 4.85938 2.21093V2.77456H8.34688V2.21093C8.34688 2.06144 8.28564 1.91808 8.17663 1.81238C8.06763 1.70668 7.91978 1.64729 7.76562 1.64729H5.44063ZM9.50938 2.77456V2.21093C9.50938 1.76247 9.32566 1.33238 8.99864 1.01528C8.67163 0.698168 8.2281 0.52002 7.76562 0.52002H5.44063C4.97815 0.52002 4.53462 0.698168 4.20761 1.01528C3.88059 1.33238 3.69688 1.76247 3.69688 2.21093V2.77456H2.53438C2.21336 2.77456 1.95312 3.02691 1.95312 3.3382V11.2291C1.95312 11.6776 2.13684 12.1077 2.46386 12.4248C2.79087 12.7419 3.2344 12.92 3.69688 12.92H9.50938C9.97185 12.92 10.4154 12.7419 10.7424 12.4248C11.0694 12.1077 11.2531 11.6776 11.2531 11.2291V3.3382C11.2531 3.02691 10.9929 2.77456 10.6719 2.77456H9.50938ZM3.11563 3.90184V11.2291C3.11563 11.3786 3.17686 11.522 3.28587 11.6277C3.39487 11.7334 3.54272 11.7927 3.69688 11.7927H9.50938C9.66353 11.7927 9.81137 11.7334 9.92038 11.6277C10.0294 11.522 10.0906 11.3786 10.0906 11.2291V3.90184H3.11563Z",
    fill: "#BCC6D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56989 5.68652C5.85524 5.68652 6.08656 5.91784 6.08656 6.20319V9.30319C6.08656 9.58854 5.85524 9.81986 5.56989 9.81986C5.28454 9.81986 5.05322 9.58854 5.05322 9.30319V6.20319C5.05322 5.91784 5.28454 5.68652 5.56989 5.68652Z",
    fill: "#BCC6D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.63678 5.68652C7.92213 5.68652 8.15345 5.91784 8.15345 6.20319V9.30319C8.15345 9.58854 7.92213 9.81986 7.63678 9.81986C7.35144 9.81986 7.12012 9.58854 7.12012 9.30319V6.20319C7.12012 5.91784 7.35144 5.68652 7.63678 5.68652Z",
    fill: "#BCC6D3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconGray);
export default __webpack_public_path__ + "static/media/deleteIconGray.9bd06a893954b293c7113ddfb042bd4a.svg";
export { ForwardRef as ReactComponent };